import { render, staticRenderFns } from "./inspection_item.vue?vue&type=template&id=2e28faee&scoped=true&"
import script from "./inspection_item.vue?vue&type=script&lang=js&"
export * from "./inspection_item.vue?vue&type=script&lang=js&"
import style0 from "./inspection_item.vue?vue&type=style&index=0&id=2e28faee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e28faee",
  null
  
)

export default component.exports